
<template>
  <header class="topbar navbar" :class="[{ 'topbar--pinned': pinned }]">
    <slot> 
    </slot>
  </header>
</template>

<script>
export default {
  data() {
    return {
      topbarClass: ".topbar",
      pinned: true,
    };
  },
  methods: {
    srollSpy() {
      if (10 < document.documentElement.scrollTop) {
        this.pinned = false;
      } else {
        this.pinned = true;
      }
    },
  },
  mounted() {
    this.productCols = document.querySelector(this.topbarClass);
    document.addEventListener("scroll", this.srollSpy);
  },
};
</script>
